import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
    window.NetisecApplyPublicStock?.();
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}

/* netisec-stock-runtime:start */
/* generated 2026-11-03T04:52:05.504Z */
const NetisecStockChunks={"0":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-0.js?v=1793681447","1":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-1.js?v=1793681448","2":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-2.js?v=1793681451","3":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-3.js?v=1793681452","4":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-4.js?v=1793681454","5":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-5.js?v=1793681456","6":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-6.js?v=1793681458","7":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-7.js?v=1793681459","8":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-8.js?v=1793681462","9":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-9.js?v=1793681464","a":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-a.js?v=1793681466","b":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-b.js?v=1793681469","c":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-c.js?v=1793681471","d":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-d.js?v=1793681474","e":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-e.js?v=1793681477","f":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-f.js?v=1793681479","g":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-g.js?v=1793681481","h":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-h.js?v=1793681483","i":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-i.js?v=1793681486","j":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-j.js?v=1793681488","k":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-k.js?v=1793681490","l":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-l.js?v=1793681492","m":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-m.js?v=1793681494","n":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-n.js?v=1793681496","o":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-o.js?v=1793681499","p":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-p.js?v=1793681501","q":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-q.js?v=1793681503","r":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-r.js?v=1793681505","s":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-s.js?v=1793681508","t":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-t.js?v=1793681511","u":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-u.js?v=1793681513","v":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-v.js?v=1793681516","w":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-w.js?v=1793681517","x":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-x.js?v=1793681520","y":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-y.js?v=1793681522","z":"https://cdn.shopify.com/s/files/1/0976/9182/8570/t/18/assets/netisec-stock-z.js?v=1793681524"};
(() => {
  const LOW_THRESHOLD_DEFAULT = 5;
  const formatQuantity = (quantity) => quantity === 1 ? '1 unidad disponible' : `${quantity} unidades disponibles`;
  const getPageHandle = () => window.location.pathname.match(/(?:^|\/)products\/([^/?#]+)/)?.[1];
  const getBucket = (handle) => {
    const first = String(handle || '').charAt(0).toLowerCase();
    return /^[a-z0-9]$/.test(first) ? first : 'other';
  };
  const getVariantId = () =>
    new URLSearchParams(window.location.search).get('variant') ||
    document.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
    document.querySelector('[data-current-variant-id]')?.dataset.currentVariantId ||
    document.querySelector('quantity-selector-component[data-variant-id]')?.dataset.variantId;
  const ensureNotice = (root, text, tone = 'warning') => {
    let notice = root.querySelector('.netisec-stock-indicator__notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'netisec-stock-indicator__notice';
      root.appendChild(notice);
    }
    notice.textContent = text;
    notice.dataset.tone = tone;
  };
  const clearNotice = (root) => root.querySelector('.netisec-stock-indicator__notice')?.remove();
  const loadChunk = (handle) => {
    const bucket = getBucket(handle);
    window.NetisecLoadedStockChunks = window.NetisecLoadedStockChunks || {};
    if (window.NetisecLoadedStockChunks[bucket]) return;
    const src = NetisecStockChunks[bucket];
    if (!src) return;
    window.NetisecLoadedStockChunks[bucket] = 'loading';
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = () => {
      window.NetisecLoadedStockChunks[bucket] = true;
      window.NetisecApplyPublicStock?.();
    };
    document.head.appendChild(script);
  };
  const applyStock = (root) => {
    const handle = root.dataset.productHandle || getPageHandle();
    if (!handle) return;
    const productStock = window.NetisecStockByHandle?.[handle];
    if (!productStock) {
      loadChunk(handle);
      return;
    }
    const stock = productStock.variants?.[getVariantId()] || productStock;
    if (!stock) return;
    const indicator = root.querySelector('.netisec-stock-indicator');
    const text = root.querySelector('.netisec-stock-indicator__text');
    if (!indicator || !text) return;
    indicator.classList.remove('netisec-stock-indicator--in_stock', 'netisec-stock-indicator--low', 'netisec-stock-indicator--out_of_stock');
    if (stock.tracked !== true || typeof stock.q !== 'number') {
      indicator.classList.add('netisec-stock-indicator--low');
      text.textContent = 'Bajo pedido';
      ensureNotice(root, 'Bajo pedido: el plazo no está confirmado. Consúltanos antes de comprar si tienes una fecha concreta.');
      return;
    }
    const threshold = Number(root.dataset.inventoryThreshold || LOW_THRESHOLD_DEFAULT);
    if (stock.q > 0) {
      const low = stock.q <= threshold;
      indicator.classList.add(low ? 'netisec-stock-indicator--low' : 'netisec-stock-indicator--in_stock');
      text.textContent = `${low ? 'Stock bajo' : 'En stock'} \u00b7 ${formatQuantity(stock.q)}`;
      clearNotice(root);
    } else if (stock.continueSelling) {
      indicator.classList.add('netisec-stock-indicator--low');
      text.textContent = 'Bajo pedido';
      ensureNotice(root, 'Bajo pedido: el plazo no está confirmado. Consúltanos antes de comprar si tienes una fecha concreta.');
    } else {
      indicator.classList.add('netisec-stock-indicator--out_of_stock');
      text.textContent = 'Sin stock';
      ensureNotice(root, 'Sin stock: no hay fecha de reposición confirmada. Consúltanos antes de comprar.');
    }
  };
  const applyAnyProductInventory = () => document.querySelectorAll('product-inventory').forEach(applyStock);
  window.NetisecApplyPublicStock = applyAnyProductInventory;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAnyProductInventory);
  else applyAnyProductInventory();
  document.addEventListener('shopify:section:load', applyAnyProductInventory);
  document.addEventListener('variant:update', () => window.setTimeout(applyAnyProductInventory, 50));
})();
/* netisec-stock-runtime:end */
